import { CharityLocation } from "../charity/CharityLocation";
import imgBuilding from "~/assets/images/icons/building.svg";
import { SizeTag } from "~/common/charity/SizeTag";
import { Tag } from "~/models/list";
import { BaseTag } from "~/common/charity/BaseTag";
import classNames from "classnames";

export const ItemHeader = ({
  name,
  city,
  state,
  tags,
}: {
  name: string;
  city?: string;
  state?: string;
  tags?: Tag[];
}) => {
  const sizeTag = tags?.[0]; // first tag is the org size
  const otherTags = tags?.slice(1);

  return (
    <div className="">
      <div className="tw:md:flex tw:md:flex-row tw:gap-4">
        <div className="tw:flex-1">
          <img
            src={imgBuilding}
            alt="building icon"
            className="tw:w-12 tw:h-12 tw:mb-2"
          />
        </div>
        <div className="tw:flex-4 tw:h-[75px]">
          <div
            className={classNames(
              "tw:mt-0 tw:mb-1",
              "tw:font-semibold tw:text-xl tw:text-cn-search ",
              "tw:line-clamp-2 tw:tracking-normal tw:lg:tracking-[-0.2px]",
            )}
          >
            {name}
          </div>
          <div className="tw:text-base tw:text-[#49516f] tw:mb-3 tw:lg:mb-4">
            <CharityLocation city={city ?? ""} state={state ?? ""} />
          </div>
        </div>
      </div>
      <div className=" tw:h-[75px] tw:max-h-[75px]">
        <div className="tw:flex tw:flex-wrap tw:pt-2 tw:pb-4">
          <SizeTag tag={sizeTag} />
          {otherTags?.map((tag, index) => <BaseTag key={index} tag={tag} />)}
        </div>
      </div>
    </div>
  );
};
